/* Age Overlay */
function isAgeVerified(cookieName) {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for(let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        // Trim leading whitespace
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        // If the cookie name is found at the beginning, return true
        if (cookie.indexOf(name) === 0) {
            return true;
        }
    }
    return false;
}

document.addEventListener('DOMContentLoaded', function () {
    // Age verification
    const ageOverlay = document.querySelector(".age-overlay");
    const yesButton = ageOverlay.querySelector(".yes-button");
    const cookieName = 'age_verified';

    // Conditionally set the overlay to active if the cookie does not exist
    if (!isAgeVerified(cookieName)) {
        ageOverlay.classList.add("active");
    }

    // Add a click event listener to the "yes" button
    yesButton.addEventListener("click", function() {
        // Set the cookie to expire in 24 hours (86400 seconds)
        document.cookie = `${cookieName}=true; max-age=86400; path=/`;
        
        // Remove the overlay's active class
        ageOverlay.classList.remove("active");
    });
    /* End Age Overlay */

    /* Header elements */
    const headerMobileHamburger = document.querySelector(".header-mobile-hamburger-container img");
    const headerMobileMenu = document.querySelector(".header-mobile-menu");

    const headerIconCart = document.querySelector(".header-icon-cart");
    const headerIconCartBubble = headerIconCart.querySelector(".header-quantity-bubble");
    const headerIconCartText = headerIconCart.querySelector(".text");

    headerMobileHamburger.addEventListener("click", function() {
        if (!headerMobileMenu.classList.contains("active")) {
            headerMobileMenu.classList.add("active");
            headerMobileHamburger.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/close_9db6c7ed-fcf3-4217-afb7-7bc7b5507d8d.png?v=1768963149");
        }
        else {
            headerMobileMenu.classList.remove("active");
            headerMobileHamburger.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/hamburger.png?v=1768958196");
        }
    });
    /* End Header elements */

    /* Cart Sidebar Unique Elements */
    const cartDrawer = document.querySelector(".cart-drawer-new");
    const cartDrawerBackground = cartDrawer.querySelector(".cart-drawer-background");
    const cartDrawerClose = cartDrawer.querySelector(".cart-drawer-close");

    // Close when esc was pressed
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            cartDrawer.classList.remove("active")
        }
    });

    // Open when cart icon in header is clicked
    headerIconCart.addEventListener("click", function() {
        cartDrawer.classList.add("active");
    });

    // Close when background is clicked
    cartDrawerBackground.addEventListener("click", function() {
        cartDrawer.classList.remove("active");
    });

    // Close when x is clicked
    cartDrawerClose.addEventListener("click", function() {
        cartDrawer.classList.remove("active");
    });
    /* End Cart Sidebar Unique Elements */

    // Cart Sidebar products and count total for current item count
    const cartDrawerProducts = cartDrawer.querySelectorAll(".cart-drawer-item-row");
    let currentItemCount = 0;
    for (let i = 0; i < cartDrawerProducts.length; i++) {
        const quantityDiv = document.querySelector(".cart-drawer-quantity-text");
        const quantity = parseInt(quantityDiv.innerHTML);

        currentItemCount += quantity;
    }

    /** Check if Bundle page or not **/
    let isBundlePage = false;
    const bundlePage = document.querySelector(".bundle-page");
    let bundleSection;
    let bundleProducts;
    
    if (bundlePage) {
        isBundlePage = true;
        bundleSection = document.querySelector(".bundle-section");
        bundleProducts = bundleSection.querySelectorAll(".right-column .product");
    }

    /** Check if Product page or not */
    let isProductPage = false;
    const productPage = document.querySelector(".product-page");

    if (productPage) {
        isProductPage = true;
    }

    /* Bundle Collapse and Expand Handler */
    let rightColumn;
    let bundleProductContainer;
    let bundleMiddle;
    let expandCollapse;
    let bundleBottomRow;

    if (isBundlePage) {
        rightColumn = bundleSection.querySelector(".right-column");
        bundleProductContainer = rightColumn.querySelector(".product-container")
        bundleMiddle = rightColumn.querySelector(".middle")
        expandCollapse = rightColumn.querySelector(".expand-collapse");
        bundleBottomRow = rightColumn.querySelector(".bottom-row");

        expandCollapse.addEventListener("click", function() {
            let height = 0;

            const products = bundleSection.querySelectorAll(".right-column .product");

            for (let i = 0; i < products.length; i++) {
                height += 50;
                
                if (i > 0) {
                    height += 4;
                }
            }

            if (rightColumn.classList.contains("expanded")) {
                
                if (height > 241) {
                    height = 241;
                    bundleMiddle.style.overflowY = "auto";
                }
                else {
                    bundleMiddle.style.overflowY = "hidden";
                }

                bundleMiddle.style.height = `${height}px`;

                bundleBottomRow.style.height = "20px";
                bundleBottomRow.style.marginBottom = "20px";

                this.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/down-arrow_1_9b936f36-422c-468a-afc1-d9be7b86337f.png?v=1768452983");
                rightColumn.classList.remove("expanded");
            }
            else {
                if (height > 241) {
                    height = 241;
                    bundleMiddle.style.overflowY = "auto";
                }
                else {
                    bundleMiddle.style.overflowY = "hidden";
                }

                bundleMiddle.style.height = 0;
                bundleBottomRow.style.height = 0;
                bundleBottomRow.style.marginBottom = 0;

                this.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/up-arrow.webp?v=1768453066");
                rightColumn.classList.add("expanded");
            }
        });
    }
    /* End Bundle Collapse and Expand Handler */

    /* Progress Bars */
    const cartDrawerFirstPart = cartDrawer.querySelector(".first-part .cart-drawer-progress-fill");
    const cartDrawerSecondPart = cartDrawer.querySelector(".second-part .cart-drawer-progress-fill");
    const cartDrawerThirdPart = cartDrawer.querySelector(".third-part .cart-drawer-progress-fill");

    let bundleFirstPart;
    let bundleSecondPart;
    let bundleThirdPart;
    if (isBundlePage) {
        bundleFirstPart = bundleSection.querySelector(".first-part .fill");
        bundleSecondPart = bundleSection.querySelector(".second-part .fill");
        bundleThirdPart = bundleSection.querySelector(".third-part .fill");
    }
    /* End Progress Bars */

    /* Bag Containers */
    let bundleBag1;
    let bundleBag2;
    let bundleBag3;
    if (isBundlePage) {
        bundleBag1 = bundleSection.querySelector(".bag-1");
        bundleBag2 = bundleSection.querySelector(".bag-2");
        bundleBag3 = bundleSection.querySelector(".bag-3");
    }
    /* End Bag Containers */

    /* Discount Text */
    const cartDrawerDiscountText = cartDrawer.querySelector(".cart-drawer-discount-text");

    let bundleInstructionsText;
    let bundleDiscountTextContainer;
    let bundleDiscountText;
    if (isBundlePage) {
        bundleInstructionsText = bundleSection.querySelector(".instructions-text");
        bundleDiscountTextContainer = bundleSection.querySelector('.discount-text-container');
        bundleDiscountText = bundleSection.querySelector(".discount-text");
    }
    /* End Discount Text */

    /* Update Discount Text */
    function updateDiscountText(itemQuantity) {
        if (itemQuantity < 3) {
            const until_discount = 3 - itemQuantity;

            let plural = "";

            if (until_discount != 1) {
                plural = "s";
            }

            cartDrawerDiscountText.innerHTML = `ADD ${until_discount} MORE BAG${plural} TO GET 20% OFF`;

            if (isBundlePage) {
                bundleInstructionsText.innerHTML = `Add ${until_discount} more product${plural} to save`;

                bundleDiscountTextContainer.style.height = 0;
                bundleDiscountTextContainer.style.paddingBottom = 0;
                bundleDiscountTextContainer.style.paddingTop = "10px";
            }
        }
        else if (itemQuantity >= 3 && itemQuantity < 5) {
            const until_discount = 5 - itemQuantity;
            
            let plural = "";

            if (until_discount != 1) {
                plural = "s";
            }

            cartDrawerDiscountText.innerHTML = `YOU UNLOCKED 20% OFF – ADD ${until_discount} MORE BAG${plural} TO GET 25% OFF`;

            if (isBundlePage) {
                bundleInstructionsText.innerHTML = `Add ${until_discount} more product${plural} to get 25% off`;

                bundleDiscountText.innerHTML = "20% Discount Unlocked!";

                bundleDiscountTextContainer.style.height = "45px";
                bundleDiscountTextContainer.style.paddingBottom = "10px";
                bundleDiscountTextContainer.style.paddingTop = "10px";
            }
        }
        else if (itemQuantity >= 5 && itemQuantity < 10) {
            const until_discount = 10 - itemQuantity;
            
            let plural = "";

            if (until_discount != 1) {
                plural = "s";
            }

            cartDrawerDiscountText.innerHTML = `YOU UNLOCKED 25% OFF – ADD ${until_discount} MORE BAG${plural} TO GET 30% OFF`;

            if (isBundlePage) {
                bundleInstructionsText.innerHTML = `Add ${until_discount} more product${plural} to get 30% off`;

                bundleDiscountText.innerHTML = "25% Discount Unlocked!";

                bundleDiscountTextContainer.style.height = "45px";
                bundleDiscountTextContainer.style.paddingBottom = "10px";
                bundleDiscountTextContainer.style.paddingTop = "10px";
            }
        }
        else if (itemQuantity >= 10) {
            cartDrawerDiscountText.innerHTML = "You have unlocked 30% off!";

            if (isBundlePage) {
                bundleInstructionsText.innerHTML = `You have unlocked 30% off!`;

                bundleDiscountText.innerHTML = "30% Discount Unlocked!";

                bundleDiscountTextContainer.style.height = "45px";
                bundleDiscountTextContainer.style.paddingBottom = "10px";
                bundleDiscountTextContainer.style.paddingTop = "10px";
            }
        }
    }
    /* End Update Discount Text */

    /* Product Containers */
    const cartDrawerCheckoutContainer = cartDrawer.querySelector(".cart-drawer-checkout-container");

    let bundleCheckoutContainer;
    if (isBundlePage) {
        bundleCheckoutContainer = bundleSection.querySelector(".checkout-button-container");
    }
    /* End Product Containers */

    /* Update Checkout Button */
    function updateCheckoutButton(itemQuantity) {
        if (itemQuantity > 0) {
            let height = 0;

            const cartDrawerCheckoutButton = cartDrawerCheckoutContainer.querySelector(".cart-drawer-checkout-button");
            const cartDrawerMoneyBack = cartDrawerCheckoutContainer.querySelector(".cart-drawer-money-back-guarantee-container");

            height += cartDrawerCheckoutButton.offsetHeight;
            height += cartDrawerMoneyBack.offsetHeight;
            height += 10;

            cartDrawerCheckoutContainer.style.height = `${height}px`;

            if (isBundlePage) {
                bundleCheckoutContainer.style.height = "95px";
                bundleCheckoutContainer.style.paddingTop = "15px";
                bundleCheckoutContainer.style.paddingBottom = "20px";
            }
        }
        else {
            cartDrawerCheckoutContainer.style.height = 0;

            if (isBundlePage) {
                bundleCheckoutContainer.style.height = 0;
                bundleCheckoutContainer.style.paddingTop = "15px";
                bundleCheckoutContainer.style.paddingBottom = 0;
            }
        }
    }
    /* End Update Checkout Button */

    /* Update Cart Icon */
    function updateCartIcon(itemQuantity) {
        if (itemQuantity == 0) {
            headerIconCartBubble.style.display = "none";
        }
        else {
            headerIconCartText.innerHTML = itemQuantity;
            headerIconCartBubble.style.display = "flex";
        }
    }
    /* End Update Cart Icon */

    /* Update total prices */
    function updateTotalPrice(newTotal, discountTotal) {
        const cartDrawerTotalPrice = cartDrawer.querySelector(".cart-drawer-total-price");
        const cartDrawerSubtotalDiscountAmount = cartDrawer.querySelector(".cart-drawer-subtotal-discount-amount");

        newTotal = newTotal.toFixed(2);
        discountTotal = discountTotal.toFixed(2);

        cartDrawerTotalPrice.innerHTML = `$${newTotal}`;
        cartDrawerSubtotalDiscountAmount.innerHTML = `(-$${discountTotal})`;

        if (discountTotal == 0) {
            cartDrawerSubtotalDiscountAmount.style.display = "none";
        }
        else {
            cartDrawerSubtotalDiscountAmount.style.display = "block";
        }
    }
    /* End update total prices */

    // Show Add to Bundle
    function showAddtoBundle(variantId) {
        if (isBundlePage) {
            const product = document.querySelector(`.left-column .product[data-variant-id="${variantId}"]`);
            const bundleButton = product.querySelector(".bundle-button");
            const bundleProductQuantityContainer = product.querySelector(".bundle-product-quantity-container");

            bundleButton.style.display = "flex";
            bundleProductQuantityContainer.style.display = "none"; 
        }
    }

    // Update progress bar
    function updateProgressBar(newItemCount) {
        // Current item count 10+
        if (currentItemCount >= 10) {
            // New item count 5 - 10
            if (newItemCount < 10 && newItemCount >= 5) {
                const barWidth = 5 - (10 - newItemCount);

                cartDrawerThirdPart.style.width = `calc(100%/5 * ${barWidth})`;

                if (isBundlePage) {
                    bundleBag3.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.width = `calc(100%/5 * ${barWidth})`;
                }
            }
            // New item count 3 - 4
            if (newItemCount < 5 && newItemCount >= 3) {
                const barWidth = 2 - (5 - newItemCount);

                cartDrawerThirdPart.style.width = 0;

                if (isBundlePage) {
                    bundleBag3.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.width = 0;
                }

                setTimeout(() => {
                    cartDrawerSecondPart.style.width = `calc(100%/2 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleBag2.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.width = `calc(100%/2 * ${barWidth})`;
                    }
                }, 400);
            }
            // New item count 0 - 2
            if (newItemCount < 3) {
                const barWidth = 3 - (3 - newItemCount);

                cartDrawerThirdPart.style.width = 0;

                if (isBundlePage) {
                    bundleBag3.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.backgroundColor = "rgb(255, 194, 105)";
                    bundleThirdPart.style.width = 0;
                }

                setTimeout(() => {
                    cartDrawerSecondPart.style.width = 0;

                    if (isBundlePage) {
                        bundleBag2.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.width = 0;
                    }
                }, 400);

                setTimeout(() => {
                    cartDrawerFirstPart.style.width = `calc(100%/3 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleBag1.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleFirstPart.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleFirstPart.style.width = `calc(100%/3 * ${barWidth})`;
                    }
                }, 800);
            }
        }
        // Current item count 5 - 9
        else if (currentItemCount >= 5 && currentItemCount < 10) {
            // New item range 5 - 9
            if (newItemCount >= 5 && newItemCount < 10) {
                const barWidth = 5 - (10 - newItemCount);
                cartDrawerThirdPart.style.width = `calc(100%/5 * ${barWidth})`;

                if (isBundlePage) {
                    bundleThirdPart.style.width = `calc(100%/5 * ${barWidth})`;
                }
            }
            // ascending
            else if (newItemCount >= 10) {
               cartDrawerThirdPart.style.width = "100%";

                if (isBundlePage) {
                    bundleThirdPart.style.width = "100%";

                    setTimeout(() => { 
                        bundleThirdPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag3.style.backgroundColor = "rgb(247, 77, 38)";
                    }, 400)
                }
            }
            // descending
            else if (newItemCount < 5) {
                const barWidth = 2 - (5 - newItemCount);

                cartDrawerThirdPart.style.width = "0";

                if (isBundlePage) {
                    bundleThirdPart.style.width = "0";
                }

                setTimeout(() => {
                    cartDrawerSecondPart.style.width = `calc(100%/2 * ${barWidth})`;

                    if (isBundlePage) { 
                        bundleBag2.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleSecondPart.style.width = `calc(100%/2 * ${barWidth})`;
                    }
                }, 400);

                if (newItemCount < 3) {
                    const barWidth = 3 - (3 - newItemCount);

                    setTimeout(() => { 
                        cartDrawerFirstPart.style.width = `calc(100%/3 * ${barWidth})`;

                        if (isBundlePage) {
                            bundleBag1.style.backgroundColor = "rgb(255, 194, 105)";
                            bundleFirstPart.style.backgroundColor = "rgb(255, 194, 105)";
                            bundleFirstPart.style.width = `calc(100%/3 * ${barWidth})`;
                        }
                    }, 800);
                }
            }
        }
        // Current item count 3 - 4 
        else if (currentItemCount >= 3 && currentItemCount < 5) {
            // New item count 3 - 4
            if (newItemCount >= 3 && newItemCount < 5) {
                const barWidth = 2 - (5 - newItemCount);
                cartDrawerSecondPart.style.width = `calc(100%/2 * ${barWidth})`;;

                if (isBundlePage) {
                    bundleSecondPart.style.width = `calc(100%/2 * ${barWidth})`;;
                }
            }
            // ascending 
            else if (newItemCount >= 5) {
                cartDrawerSecondPart.style.width = "100%";

                if (isBundlePage) {
                    bundleSecondPart.style.width = "100%";
                }

                setTimeout(() => { 
                    const barWidth = 5 - (10 - newItemCount);

                    cartDrawerThirdPart.style.width = `calc(100%/5 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleSecondPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag2.style.backgroundColor = "rgb(247, 77, 38)";

                        bundleThirdPart.style.width = `calc(100%/5 * ${barWidth})`;
                    }
                }, 400);

                if (newItemCount >= 10) {
                    setTimeout(() => { 
                        cartDrawerThirdPart.style.width = "100%";

                        if (isBundlePage) {
                            bundleThirdPart.style.width = "100%";
                        }
                    }, 800);

                    setTimeout(() => {
                        bundleThirdPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag3.style.backgroundColor = "rgb(247, 77, 38)";
                    }, 1200);
                }
            }
            // decscending
            else if (newItemCount < 3) {
                cartDrawerSecondPart.style.width = "0";

                if (isBundlePage) {
                    bundleSecondPart.style.width = "0";
                }

                setTimeout(() => {
                    const barWidth = 3 - (3 - newItemCount);
                    cartDrawerFirstPart.style.width = `calc(100%/3 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleBag1.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleFirstPart.style.backgroundColor = "rgb(255, 194, 105)";
                        bundleFirstPart.style.width = `calc(100%/3 * ${barWidth})`;
                    }
                }, 400)
            }
        }
        // current item count 0 - 2 
        else if (currentItemCount >= 0 && currentItemCount < 3) {
            if (newItemCount >= 0) {
                const barWidth = 3 - (3 - newItemCount);
                cartDrawerFirstPart.style.width = `calc(100%/3 * ${barWidth})`;

                if (isBundlePage) {
                    bundleFirstPart.style.width = `calc(100%/3 * ${barWidth})`;
                }
            }
            if (newItemCount >= 3) {
                const barWidth = 2 - (5 - newItemCount);

                cartDrawerFirstPart.style.width = "100%";

                setTimeout(() => {
                    cartDrawerSecondPart.style.width = `calc(100%/2 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleFirstPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag1.style.backgroundColor = "rgb(247, 77, 38)";

                        bundleSecondPart.style.width = `calc(100%/2 * ${barWidth})`;
                    }
                }, 400);
            }
            if (newItemCount >= 5) {
                const barWidth = 5 - (10 - newItemCount);

                setTimeout(() => {
                    cartDrawerSecondPart.style.width = "100%";

                    if (isBundlePage) {
                        bundleSecondPart.style.width = "100%";
                    }
                }, 400);

                setTimeout(() => {
                    cartDrawerThirdPart.style.width = `calc(100%/5 * ${barWidth})`;

                    if (isBundlePage) {
                        bundleSecondPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag2.style.backgroundColor = "rgb(247, 77, 38)";

                        bundleThirdPart.style.width = `calc(100%/5 * ${barWidth})`;
                    }
                }, 800);
            }
            if (newItemCount >= 10) {
                setTimeout(() => {
                    cartDrawerThirdPart.style.width = "100%";

                    if (isBundlePage) {
                        bundleThirdPart.style.width = "100%";
                    }
                }, 800);

                setTimeout(() => {
                    if (isBundlePage) {
                        bundleThirdPart.style.backgroundColor = "rgb(247, 77, 38)";
                        bundleBag3.style.backgroundColor = "rgb(247, 77, 38)";
                    }
                }, 1200);
            }
        }
    }

    // Update UI
    function updateUI(updatedCart, variantId) {
        const updatedItemCount = updatedCart.item_count;
        const totalPrice = updatedCart.total_price / 100;
        const totalDiscount = updatedCart.total_discount / 100;

        updateDiscountText(updatedItemCount);
        updateProgressBar(updatedItemCount);
        updateCheckoutButton(updatedItemCount);
        updateCartIcon(updatedItemCount);
        updateTotalPrice(totalPrice, totalDiscount);
        currentItemCount = updatedItemCount;
    }

    // Attach bundle event listeners 
    if (isBundlePage) {
        for (let i = 0; i < bundleProducts.length; i++) {
            attachBundleEventListeners(bundleProducts[i]);
        }
    }

    // Attach bundle event listeners
    function attachBundleEventListeners(product) {
        const variantId = product.getAttribute("data-variant-id");

        // Trash event listeners
        const trashButton = product.querySelector(".trash");
        trashButton.addEventListener("click", async function() {
            const trashLoading = product.querySelector(".trash-loading");
            const cartDrawerRow = document.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"]`);

            this.remove();
            trashLoading.style.display = "block";

            // Execute the delete function
            const updatedCart = await removeVariantFromCart(variantId);

            if (updatedCart) {
                product.remove();
                cartDrawerRow.remove();

                updateUI(updatedCart, variantId);
                showAddtoBundle(variantId);
            }

            // Set bundle products height if open
            if (!rightColumn.classList.contains("expanded")) {
                const bundleProducts = rightColumn.querySelectorAll(".product");
                let height = 0;
                
                for (let j = 0; j < bundleProducts.length; j++) {
                    height += bundleProducts[j].offsetHeight;
                    if (j > 0) {
                        height += 4;
                    }
                }

                bundleMiddle.style.height = `${height}px`;
            }
        });

        const stepButtons = product.querySelectorAll(".step");
        for (let i = 0; i < stepButtons.length; i++) {
            stepButtons[i].addEventListener("click", async function() {
                const product = this.closest(".product");
                const variantId = product.getAttribute("data-variant-id");

                const numberLoading = product.querySelector(".number-loading");
                const number = product.querySelector(".number");

                number.style.display = "none";
                numberLoading.style.display = "block";

                const numberValue = parseInt(number.innerHTML);

                let updatedCart;

                // Decrement
                if (this.classList.contains("decrement")) { 
                    updatedCart = await updateVariantQuantity(variantId, numberValue - 1);
                }
                // Increment;
                else { 
                    updatedCart = await updateVariantQuantity(variantId, numberValue + 1);
                }

                // Find the specific row in the cart that matches your variantId
                const targetItem = updatedCart.items.find(item => item.variant_id.toString() === variantId.toString());

                // Assign the quantity (using 0 as a fallback if the item was removed)
                const updatedItemCount = targetItem ? targetItem.quantity : 0;

                let cartDrawerProduct = document.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"]`);
                let cartDrawerQuantityNumber = cartDrawerProduct.querySelector(".cart-drawer-quantity-text");

                let selectionProduct = document.querySelector(`.left-column .product[data-variant-id="${variantId}"]`)
                let selectionProductQuantityNumber = selectionProduct.querySelector(".bundle-product-quantity-number .text");

                if (updatedItemCount == 0) {
                    product.remove();
                    cartDrawerProduct.remove();
                    showAddtoBundle(variantId)

                    // Set bundle products height if open
                    if (!rightColumn.classList.contains("expanded")) {
                        const bundleProducts = rightColumn.querySelectorAll(".product");
                        let height = 0;
                        
                        for (let j = 0; j < bundleProducts.length; j++) {
                            height += bundleProducts[j].offsetHeight;
                            if (j > 0) {
                                height += 4;
                            }
                        }

                        bundleMiddle.style.height = `${height}px`;
                    }
                }
                else {
                    number.innerHTML = updatedItemCount;
                    numberLoading.style.display = "none";
                    number.style.display = "block";

                    cartDrawerQuantityNumber.innerHTML = updatedItemCount;
                    selectionProductQuantityNumber.innerHTML = updatedItemCount;

                    const finalLinePrice = targetItem.final_line_price / 100;

                    const linePriceDiv = cartDrawer.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"] .cart-drawer-item-price`);
                    linePriceDiv.innerHTML = `$${finalLinePrice.toFixed(2)}`;
                }

                updateUI(updatedCart, variantId);
            });
        }
    }

    // Attach cart drawer event listeners
    for (let i = 0; i < cartDrawerProducts.length; i++) {
        attachCartDrawerEventListeners(cartDrawerProducts[i]);
    }

    // Attach cart drawer event listeners
    function attachCartDrawerEventListeners(product) {
        const variantId = product.getAttribute("data-variant-id");
        
        // Trash event listeners
        const trashButton = product.querySelector(".cart-drawer-item-trash");
        trashButton.addEventListener("click", async function() {
            const trashLoading = product.querySelector(".cart-drawer-trash-loading");
            let cartBundleRow;

            if (isBundlePage) {
                cartBundleRow = document.querySelector(`.product-container .product[data-variant-id="${variantId}"]`);
            }

            this.remove();
            trashLoading.style.display = "block";

            // Execute the delete function
            const updatedCart = await removeVariantFromCart(variantId);

            if (updatedCart) {
                product.remove();

                if (isBundlePage) {
                    cartBundleRow.remove();
                }

                updateUI(updatedCart, variantId);

                if (isBundlePage) {
                    showAddtoBundle(variantId);
                }
            }

            // Set bundle products height if open
            if (isBundlePage) {
                if (!rightColumn.classList.contains("expanded")) {
                    const bundleProducts = rightColumn.querySelectorAll(".product");
                    let height = 0;
                    
                    for (let j = 0; j < bundleProducts.length; j++) {
                        height += bundleProducts[j].offsetHeight;
                        if (j > 0) {
                            height += 4;
                        }
                    }

                    bundleMiddle.style.height = `${height}px`;
                }
            }
        });

        const stepButtons = product.querySelectorAll(".cart-drawer-quantity-step");
        for (let i = 0; i < stepButtons.length; i++) {
            stepButtons[i].addEventListener("click", async function() {
                const product = this.closest(".cart-drawer-item-row");
                const variantId = product.getAttribute("data-variant-id");

                const numberLoading = product.querySelector(".cart-drawer-quantity-loading");
                const number = product.querySelector(".cart-drawer-quantity-text");

                number.style.display = "none";
                numberLoading.style.display = "block";

                const numberValue = parseInt(number.innerHTML);

                let updatedCart;

                // Decrement
                if (this.classList.contains("decrement")) { 
                    updatedCart = await updateVariantQuantity(variantId, numberValue - 1);
                }
                // Increment;
                else { 
                    updatedCart = await updateVariantQuantity(variantId, numberValue + 1);
                }

                // Find the specific row in the cart that matches your variantId
                const targetItem = updatedCart.items.find(item => item.variant_id.toString() === variantId.toString());

                // Assign the quantity (using 0 as a fallback if the item was removed)
                const updatedItemCount = targetItem ? targetItem.quantity : 0;

                let bundleProduct; 
                let bundleQuantityNumber;

                if (isBundlePage) {
                    bundleProduct = document.querySelector(`.right-column .product[data-variant-id="${variantId}"]`);
                    bundleQuantityNumber = bundleProduct.querySelector(".number");
                }

                let selectionProduct;
                let selectionProductQuantityNumber;

                if (isBundlePage) {
                    selectionProduct = document.querySelector(`.left-column .product[data-variant-id="${variantId}"]`)
                    selectionProductQuantityNumber = selectionProduct.querySelector(".bundle-product-quantity-number .text");
                }

                if (updatedItemCount == 0) {
                    product.remove();

                    if (isBundlePage) {
                        bundleProduct.remove();
                        showAddtoBundle(variantId)

                        // Set bundle products height if open
                        if (!rightColumn.classList.contains("expanded")) {
                            const bundleProducts = rightColumn.querySelectorAll(".product");
                            let height = 0;
                            
                            for (let j = 0; j < bundleProducts.length; j++) {
                                height += bundleProducts[j].offsetHeight;
                                if (j > 0) {
                                    height += 4;
                                }
                            }

                            bundleMiddle.style.height = `${height}px`;
                        }
                    }
                }
                else {
                    number.innerHTML = updatedItemCount;
                    numberLoading.style.display = "none";
                    number.style.display = "block";

                    if (isBundlePage) {
                        bundleQuantityNumber.innerHTML = updatedItemCount;
                        selectionProductQuantityNumber.innerHTML = updatedItemCount;
                    }

                    const finalLinePrice = targetItem.final_line_price / 100;

                    const linePriceDiv = cartDrawer.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"] .cart-drawer-item-price`);
                    linePriceDiv.innerHTML = `$${finalLinePrice.toFixed(2)}`;
                }

                updateUI(updatedCart, variantId);
            });
        }
    }

    // Add buttons handler 
    let addButtons; 
    if (isBundlePage) {
        addButtons = document.querySelectorAll(".bundle-button");
        for (let i = 0; i < addButtons.length; i++) {
            addButtons[i].addEventListener("click", async function() {
                const product = this.closest(".product");
                const variantId = product.getAttribute("data-variant-id");
                const bundleLoading = product.querySelector(".bundle-loading");
                const bundleProductQuantityContainer = product.querySelector(".bundle-product-quantity-container");
                const bundleProductQuantityNumber = bundleProductQuantityContainer.querySelector(".bundle-product-quantity-number .text");

                this.style.display = "none";
                bundleLoading.style.display = "block";

                const updatedCart = await addOneToCart(variantId);

                // Ensure the cart exists and find the specific item you just added
                if (updatedCart && updatedCart.items) {
                    updateUI(updatedCart, variantId);
                    const itemData = updatedCart.items.find(item => item.variant_id.toString() === variantId.toString());

                    if (itemData) {
                        bundleLoading.style.display = "none";

                        const productContainer = bundleSection.querySelector(".selection-container .product-container");

                        // Use itemData properties (note: Shopify uses .image for line items in cart.js)
                        const productHtml = `
                            <div class="product" data-variant-id="${itemData.variant_id}">
                                <div class="left-section">
                                    <img class="product-image" src="${itemData.image}" alt="${itemData.product_title}">
                                    <div class="product-title">${itemData.product_title}</div>
                                </div>
                                <div class="right-section">
                                    <div class="quantity-container">
                                        <div class="step decrement">-</div>
                                        <div class="number-container">
                                            <img class="number-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                            <div class="number">${itemData.quantity}</div>
                                        </div>
                                        <div class="step increment">+</div>
                                    </div>
                                    <img class="trash" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/delete.png?v=1767583681">
                                    <img class="trash-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                </div>
                            </div>
                        `;

                        bundleProductQuantityNumber.innerHTML = 1;
                        bundleProductQuantityContainer.style.display = "flex";

                        productContainer.insertAdjacentHTML('beforeend', productHtml);

                        // Re-attach listeners to the brand new HTML elements
                        const newProductEntry = productContainer.lastElementChild;
                        attachBundleEventListeners(newProductEntry);

                        // Format the price (Shopify returns cents, e.g., 2624 -> $26.24)
                        const formattedPrice = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(itemData.final_line_price / 100);

                        // Set bundle products height if open
                        if (!rightColumn.classList.contains("expanded")) {
                            const bundleProducts = rightColumn.querySelectorAll(".product");
                            let height = 0;
                            
                            for (let j = 0; j < bundleProducts.length; j++) {
                                height += bundleProducts[j].offsetHeight;
                                if (j > 0) {
                                    height += 4;
                                }
                            }

                            bundleMiddle.style.height = `${height}px`;
                        }

                        // Define the Cart Drawer Row HTML
                        const cartDrawerHtml = `
                            <div class="cart-drawer-item-row" data-variant-id="${itemData.variant_id}">
                                <img class="cart-drawer-item-image" src="${itemData.image}">
                                <div class="cart-drawer-item-details">
                                    <div class="cart-drawer-item-left">
                                        <div class="cart-drawer-item-title">${itemData.product_title}</div>
                                        <div class="cart-drawer-quantity-container">
                                            <div class="cart-drawer-quantity-step decrement">–</div>
                                            <div class="cart-drawer-quantity-number">
                                                <div class="cart-drawer-quantity-text">${itemData.quantity}</div>
                                                <img class="cart-drawer-quantity-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                            </div>
                                            <div class="cart-drawer-quantity-step increment">+</div>
                                        </div>
                                    </div>
                                    <div class="cart-drawer-item-right">
                                        <img class="cart-drawer-item-trash" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/delete.png?v=1767583681">
                                        <img class="cart-drawer-trash-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                        <div class="cart-drawer-item-price">${formattedPrice}</div>
                                    </div>
                                </div>
                            </div>
                        `;

                        // Inject into the Drawer
                        const drawerContainer = document.querySelector(".cart-drawer-items-container");
                        if (drawerContainer) {
                            drawerContainer.insertAdjacentHTML('beforeend', cartDrawerHtml);
                            
                            // Attach listeners to the new Drawer row
                            const newDrawerRow = drawerContainer.lastElementChild;
                            attachCartDrawerEventListeners(newDrawerRow); // Assuming you have a separate function for drawer logic
                        }
                    }
                }
            });
        }
    }

    // bundle quantity buttons handler
    let bundleQuantityContainers;
    if (isBundlePage) {
        bundleQuantityContainers = document.querySelectorAll(".bundle-product-quantity-container");
        for (let i = 0; i < bundleQuantityContainers.length; i++) {
            const product = bundleQuantityContainers[i].closest(".product");
            const variantId = product.getAttribute("data-variant-id");

            const bundleQuantitySteps = product.querySelectorAll(".bundle-product-quantity-step");
            for (let j = 0; j < bundleQuantitySteps.length; j++) {
                bundleQuantitySteps[j].addEventListener("click", async function() {
                    let updatedCart;

                    const bundleQuantityNumber = product.querySelector(".bundle-product-quantity-number .text");
                    let quantityNumber = parseInt(bundleQuantityNumber.innerHTML);

                    // Decrement
                    if (this.classList.contains("decrement")) { 
                        quantityNumber--;

                        if (quantityNumber == 0) {
                            const bundleQuantityContainer = product.querySelector(".bundle-product-quantity-container");
                            const bundleLoading = product.querySelector(".bundle-loading");
                            const bundleButton = product.querySelector(".bundle-button");

                            bundleQuantityContainer.style.display = "none";
                            bundleLoading.style.display = "block";

                            updatedCart = await updateVariantQuantity(variantId, quantityNumber);
                            updateUI(updatedCart, variantId);

                            const cartDrawerItemRow = cartDrawer.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"]`);
                            const bundleProduct = bundleSection.querySelector(`.right-column .product[data-variant-id="${variantId}"]`);

                            cartDrawerItemRow.remove();
                            bundleProduct.remove();

                            bundleButton.style.display = "flex";
                            bundleLoading.style.display = "none";

                            bundleQuantityNumber.innerHTML = 0;

                            return;
                        }
                    }
                    // Increment;
                    else { 
                        quantityNumber++;
                    }

                    const bundleQuantityLoading = product.querySelector(".bundle-quantity-loading");
                    bundleQuantityNumber.style.display = "none";
                    bundleQuantityLoading.style.display = "block";

                    updatedCart = await updateVariantQuantity(variantId, quantityNumber);
                    updateUI(updatedCart, variantId);

                    bundleQuantityNumber.innerHTML = quantityNumber;

                    let cartDrawerProduct = document.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"]`);
                    let cartDrawerQuantityNumber = cartDrawerProduct.querySelector(".cart-drawer-quantity-text");
                    cartDrawerQuantityNumber.innerHTML = quantityNumber;

                    let bundleProduct = document.querySelector(`.right-column .product[data-variant-id="${variantId}"]`)
                    let bundleProductQuantityNumber = bundleProduct.querySelector(".number");
                    bundleProductQuantityNumber.innerHTML = quantityNumber;

                    // Find the specific row in the cart that matches your variantId
                    const targetItem = updatedCart.items.find(item => item.variant_id.toString() === variantId.toString());
                    const finalLinePrice = targetItem.final_line_price / 100;
                    
                    const linePriceDiv = cartDrawer.querySelector(`.cart-drawer-item-row[data-variant-id="${variantId}"] .cart-drawer-item-price`);
                    linePriceDiv.innerHTML = `$${finalLinePrice.toFixed(2)}`;

                    bundleQuantityNumber.style.display = "block";
                    bundleQuantityLoading.style.display = "none";
                });
            }
        }
    }

    // Add button product page
    let shopButton;
    if (isProductPage) {
        shopButton = document.querySelector(".shop-button");
        const variantId = shopButton.getAttribute("data-variant-id");

        shopButton.addEventListener("click", async function() {
            const quantityNumber = document.querySelector(".quantity-and-add-row .quantity-number");
            let value = parseInt(quantityNumber.innerHTML);
            
            const cartDrawer = document.querySelector(".cart-drawer-new");
            const shopButtonContainer = shopButton.querySelector(".shop-button-container");
            const shopButtonLoading = shopButton.querySelector(".shop-button-loading");

            shopButtonContainer.style.display = "none";
            shopButtonLoading.style.display = "block";

            updatedCart = await addToCart(variantId, value);
            updateUI(updatedCart, variantId);
            quantityNumber.innerHTML = 1;

            // Find the specific row in the cart that matches your variantId
            const targetItem = updatedCart.items.find(item => item.variant_id.toString() === variantId.toString());

            // Assign the quantity (using 0 as a fallback if the item was removed)
            const updatedItemCount = targetItem ? targetItem.quantity : 0;

            // Format the price (Shopify returns cents, e.g., 2624 -> $26.24)
            const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(targetItem.final_line_price / 100);

            if (updatedItemCount > value) {
                const cartDrawerQuantityText = document.querySelector(".cart-drawer-quantity-text");
                cartDrawerQuantityText.innerHTML = updatedItemCount;
            }
            else {
                // Define the Cart Drawer Row HTML
                const cartDrawerHtml = `
                    <div class="cart-drawer-item-row" data-variant-id="${targetItem.variant_id}">
                        <img class="cart-drawer-item-image" src="${targetItem.image}">
                        <div class="cart-drawer-item-details">
                            <div class="cart-drawer-item-left">
                                <div class="cart-drawer-item-title">${targetItem.product_title}</div>
                                <div class="cart-drawer-quantity-container">
                                    <div class="cart-drawer-quantity-step decrement">–</div>
                                    <div class="cart-drawer-quantity-number">
                                        <div class="cart-drawer-quantity-text">${targetItem.quantity}</div>
                                        <img class="cart-drawer-quantity-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                    </div>
                                    <div class="cart-drawer-quantity-step increment">+</div>
                                </div>
                            </div>
                            <div class="cart-drawer-item-right">
                                <img class="cart-drawer-item-trash" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/delete.png?v=1767583681">
                                <img class="cart-drawer-trash-loading" src="https://cdn.shopify.com/s/files/1/0756/0599/9854/files/loading_1.png?v=1767584491">
                                <div class="cart-drawer-item-price">${formattedPrice}</div>
                            </div>
                        </div>
                    </div>
                `;

                // Inject into the Drawer
                const drawerContainer = document.querySelector(".cart-drawer-items-container");
                if (drawerContainer) {
                    drawerContainer.insertAdjacentHTML('afterbegin', cartDrawerHtml);
                    
                    // Attach listeners to the new Drawer row
                    const newDrawerRow = drawerContainer.firstElementChild;
                    attachCartDrawerEventListeners(newDrawerRow); // Assuming you have a separate function for drawer logic
                }
            }

            shopButtonContainer.style.display = "flex";
            shopButtonLoading.style.display = "none";
            cartDrawer.classList.add("active");
        });
    }
    /* End Product Section */

    // Applies discount based on cart amount
    async function applyTieredDiscount(count) {
        let discountCode = '';

        if (count >= 10) { discountCode = 'PROM7WBH'; }
        else if (count >= 5) { discountCode = 'PROM7WYD'; }
        else if (count >= 3) { discountCode = 'SAVE8KJ2'; }

        if (discountCode) {
            try {
                // Hits the Shopify discount endpoint to apply the code to the session
                await fetch(`/discount/${discountCode}`);
                console.log(`Discount logic triggered for: ${discountCode}`);
            } catch (err) {
                console.error('Discount application failed', err);
            }
        }
    }

    // Remove variant from cart
    async function removeVariantFromCart(variantId) {
        // Start a 1-second timer for UI/loading consistency
        const minTimer = new Promise(resolve => setTimeout(resolve, 1000));

        const cartTask = (async () => {
            try {
                // Remove the item
                const removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId.toString(), quantity: 0 })
                });

                if (!removeResponse.ok) throw new Error('Failed to remove item');
                const cartAfterRemoval = await removeResponse.json();

                // Run the discount logic based on the new count
                await applyTieredDiscount(cartAfterRemoval.item_count);

                // IMPORTANT: Fetch the cart AGAIN. 
                // This ensures we get the updated "total_price" after the discount is applied.
                const finalResponse = await fetch(window.Shopify.routes.root + 'cart.js');
                return await finalResponse.json();

            } catch (error) {
                console.error('Cart update failed:', error);
                return null;
            }
        })();

        // Wait for both the minimum delay and the API work to finish
        const [_, updatedCart] = await Promise.all([minTimer, cartTask]);

        // This now contains the final prices and applied discounts
        return updatedCart;
    }

    // Update variant quantity
    async function updateVariantQuantity(variantId, newQuantity) {
        // Start the 1-second timer for UI consistency
        const minTimer = new Promise(resolve => setTimeout(resolve, 1000));

        try {
            // Perform the Shopify quantity change
            const changeRequest = fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: variantId.toString(),
                    quantity: parseInt(newQuantity)
                })
            });

            // Wait for the change and the timer
            const [response] = await Promise.all([changeRequest, minTimer]);

            if (!response.ok) throw new Error('Failed to update quantity');
            
            // This is the cart state immediately after the quantity change
            const intermediateCart = await response.json();

            // Run the tiered discount logic based on new item count
            await applyTieredDiscount(intermediateCart.item_count);

            // Final Fetch: Get the cart again to ensure discounts/totals are refreshed
            const finalResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const updatedCart = await finalResponse.json();

            // Return the entire cart object instead of just the quantity
            return updatedCart;

        } catch (error) {
            console.error('Error in updateVariantQuantity flow:', error);
            return null;
        }
    }

    // Adds 1 of a specific variant, updates discounts
    async function addOneToCart(variantId) {
        // Start the 1-second timer for UI consistency
        const minTimer = new Promise(resolve => setTimeout(resolve, 1000));

        try {
            // Add the item to the cart
            const shopifyRequest = fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: variantId.toString(),
                    quantity: 1
                })
            });

            // Wait for the addition and the timer to complete
            const [response] = await Promise.all([shopifyRequest, minTimer]);

            if (!response.ok) throw new Error('Failed to add item');
            
            // Note: cart/add.js returns the single item added.
            // We need the full cart to check the total count for discounts.
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const intermediateCart = await cartResponse.json();

            // Run the tiered discount logic based on the new total item count
            await applyTieredDiscount(intermediateCart.item_count);

            // Final Fetch: Get the cart again to ensure discounts are applied to the total
            const finalResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const updatedCart = await finalResponse.json();

            // Return the entire cart object
            return updatedCart;

        } catch (error) {
            console.error('Error adding item to cart:', error);
            return null;
        }
    }

    // Adds chosen quantity of a specific variant
    async function addToCart(variantId, addedQuantity) {
        // Start the 1-second timer for UI consistency
        const minTimer = new Promise(resolve => setTimeout(resolve, 1000));

        try {
            // Add the item to the cart
            const shopifyRequest = fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: variantId.toString(),
                    quantity: addedQuantity
                })
            });

            // Wait for the addition and the timer to complete
            const [response] = await Promise.all([shopifyRequest, minTimer]);

            if (!response.ok) throw new Error('Failed to add items');
            
            // Note: cart/add.js returns the single item added.
            // We need the full cart to check the total count for discounts.
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const intermediateCart = await cartResponse.json();

            // Run the tiered discount logic based on the new total item count
            await applyTieredDiscount(intermediateCart.item_count);

            // Final Fetch: Get the cart again to ensure discounts are applied to the total
            const finalResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const updatedCart = await finalResponse.json();

            // Return the entire cart object
            return updatedCart;

        } catch (error) {
            console.error('Error adding item to cart:', error);
            return null;
        }
    }

    async function clearCart() {
        // Start the 1-second timer for UI consistency
        const minTimer = new Promise(resolve => setTimeout(resolve, 1000));

        try {
            // Shopify clear request
            const clearRequest = fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            // Wait for both the clear request and the UI timer
            const [response] = await Promise.all([clearRequest, minTimer]);

            if (!response.ok) throw new Error('Failed to clear cart');

            /**
             * Note: clearing the cart usually means item_count is 0,
             * but we fetch the fresh cart object to ensure all 
             * discount attributes and totals are fully reset.
             */
            const finalResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const updatedCart = await finalResponse.json();

            // Optional: Trigger your discount logic for 0 items if needed
            if (typeof applyTieredDiscount === "function") {
                await applyTieredDiscount(0);
            }

            return updatedCart;

        } catch (error) {
            console.error('Error clearing cart:', error);
            return null;
        }
    }

    // Variant ID and Checkout Champ ID relations
    const productMap = [
        {
            title: "Midnight REMberry Gummies",
            variantId: "46597744656622",
            checkoutChampId: "16"
        },
        {
            title: "Strawberry Lifted Lemonade Gummies",
            variantId: "46597745475822",
            checkoutChampId: "24"
        },
        {
            title: "Blueberry Dream Gummies",
            variantId: "46597746163950",
            checkoutChampId: "9"
        },
        {
            title: "Raspberry Remedy Gummies",
            variantId: "46597956632814",
            checkoutChampId: "22"
        },
        {
            title: "Peaceful Pineapple Gummies",
            variantId: "46597956862190",
            checkoutChampId: "20"
        },
        {
            title: "Mellow Mango Gummies",
            variantId: "46597956894958",
            checkoutChampId: "13"
        },
        {
            title: "Cherry Lifted Limeade Gummies",
            variantId: "46597957026030",
            checkoutChampId: "11"
        }
    ];

const cartDrawerCheckoutButton = document.querySelector(".cart-drawer-checkout-button");


    let checkoutButton;
    if (isBundlePage) {
        checkoutButton = document.querySelector(".checkout-button");
    }
    
    addCheckoutEventListener(cartDrawerCheckoutButton);

    if (isBundlePage) {
        addCheckoutEventListener(checkoutButton);
    }

    function addCheckoutEventListener(checkoutButton) {
        checkoutButton.addEventListener("click", async function() {
            const products = document.querySelectorAll(".cart-drawer-item-row");
            let productsArray = [];
            let quantityArray = [];
            let checkoutChampArray = [];

            for (let i = 0; i < products.length; i++) {
                let variantId = products[i].getAttribute("data-variant-id");
                productsArray.push(variantId);

                let quantity = parseInt(products[i].querySelector(".cart-drawer-quantity-text").innerHTML);
                quantityArray.push(quantity);

                // Find the matching product in your reference object
                const match = productMap.find(p => p.variantId === variantId);

                // If a match is found, push the checkoutChampId to the new array
                if (match) {
                    checkoutChampArray.push(match.checkoutChampId);
                }
            }

            const baseUrl = "https://checkout.happyfruit.com/lead3";
            
            let productsUrl = "?products=";

            let count = 0;
            for (let i = 0; i < productsArray.length; i++) {
                productsUrl += checkoutChampArray[i] + ":" + quantityArray[i] + ";";
                count += quantityArray[i];
            }

            let couponCodeUrl = "&couponCode="

            if (count >= 10) { 
                couponCodeUrl += 'PROM7WBH'; 
            }
            else if (count >= 5) { 
                couponCodeUrl += 'PROM7WYD'; 
            }
            else if (count >= 3) { 
                couponCodeUrl += 'SAVE8KJ2'; 
            }

            const checkoutButtonHolder = checkoutButton.querySelector(".checkout-button-holder");
            const checkoutButtonLoading = checkoutButton.querySelector(".checkout-button-loading");

            checkoutButtonHolder.style.display = "none";
            checkoutButtonLoading.style.display = "block";

            checkoutButtonHolder.style.display = "none";
            checkoutButtonLoading.style.display = "block";

            // Keep the Shopify cart intact while the customer visits Checkout Champ.

            const finalUrl = baseUrl + productsUrl + couponCodeUrl;
            window.open(finalUrl, "_self");

            // const updatedCart = await clearCart();
            // updateUI(updatedCart, null);
        });
    }
});